import { handleJavaScriptError } from './handlers/javascriptErrorHandler';
import { handlePromiseRejection } from './handlers/promiseRejectionHandler';
import { handleResourceError } from './handlers/resourceErrorHandler';
import { overrideConsoleError } from './handlers/consoleErrorHandler';
import { getViewContext } from './utils/viewContext';
import { ErrorContext } from './types/errorTypes';

class GlobalErrorHandler {
  private isInitialized = false;

  public initialize(): void {
    if (this.isInitialized) {
      return;
    }

    window.addEventListener('error', (event) =>
      handleJavaScriptError(event, getViewContext)
    );

    window.addEventListener('unhandledrejection', (event) =>
      handlePromiseRejection(event, getViewContext)
    );

    window.addEventListener('error', handleResourceError, true);

    if (process.env.NODE_ENV === 'development') {
      overrideConsoleError();
    }

    this.isInitialized = true;
  }
}

export const globalErrorHandler = new GlobalErrorHandler();
export type { ErrorContext };